export default __webpack_public_path__ + "static/media/feedback@2x.f8565802.png";